import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

  export class CrystalClearFrontUrlSupport extends AsbCCUrl {
  // SUPPORT
  static readonly SUPPORT_SYNC: PageDescription = {
    label: 'page_title.support.sync',
    path: 'support/sync',
    icon: 'fas fa-rotate',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };
  static readonly SUPPORT_TOC: PageDescription = {
    label: 'page_title.support.toc',
    path: 'support/trade',
    icon: 'fas fa-screwdriver',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };
  static readonly SUPPORT_TRADE: PageDescription = {
    label: 'page_title.support.trade',
    path: 'support/trade',
    icon: 'fas fa-screwdriver',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };
  static readonly SUPPORT_ORDER: PageDescription = {
    label: 'page_title.support.order',
    path: 'support/order',
    icon: 'fas fa-screwdriver',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };
  static readonly SUPPORT_CLEARING: PageDescription = {
    label: 'page_title.support.clearing',
    path: 'support/clearing',
    icon: 'fas fa-screwdriver',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };

}

